import LoginWithGoogle from "./LoginWithGoogle";

export default LoginWithGoogle;
